import React from "react";
import ScrollToTop from "react-scroll-to-top";
import { ReactComponent as ScrollIcon } from "../assets/icons/scroll_up.svg";

const ScrollTop = () => {
  return <ScrollToTop smooth component={<ScrollIcon className="m-auto" />} />;
};

export default ScrollTop;
